import { Component, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { switchMap } from 'rxjs';
import { CountdownManager } from '../countdown/countdown-manager.class';

@Component({
  imports: [MatIconModule, MatButtonModule],
  selector: 'app-slideshow-header-controller',
  standalone: true,
  styleUrls: ['./slideshow-header-controller.component.scss'],
  templateUrl: './slideshow-header-controller.component.html',
})
export class SlideshowHeaderControllerComponent {
  public countdownManager = input.required<CountdownManager>();

  public isPaused = toSignal(toObservable(this.countdownManager).pipe(switchMap((mgr) => mgr.pauseSubject)), {
    initialValue: false,
  });

  public togglePause(): void {
    const mgr = this.countdownManager();

    if (mgr?.pauseSubject) {
      mgr.pauseSubject.next(!this.isPaused());
    }
  }

  public onNext(): void {
    this.countdownManager()?.manualChangeSubject.next('next');
  }

  public onPrevious(): void {
    this.countdownManager()?.manualChangeSubject.next('prev');
  }
}
